import React from 'react';
import './FooterText.css'

const FooterText = (props) => {
    return ( <>
    <div className={props.style1} > {props.text}</div>
    </> );
}
 
export default FooterText;